export const asArray = (val) => {
  if (Array.isArray(val)) {
    return val;
  }

  return [val];
};
